function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, focusedItemIndex, numColumns, searchFilter, showSelectAll) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("ul", {
        "hook": {
          postpatch: $helpers.handlePostPatch
        },
        "class": {
          'mp-checkbox-list-list': true
        },
      }, (function() {
        var __jade_nodes = [];
        const checkboxItems = $helpers.getItemsToDisplay();;
        const totalMatchingItems = $helpers.getTotalMatchingItems();;
        const displaySelectAll = showSelectAll && !searchFilter;;
        const displaySelectAllMatching = $attr(`show-csv-matches`) && searchFilter && totalMatchingItems;;
        const allMatchingItemsSelected = $helpers.allMatchingItemsSelected();;
        const allSelected = displaySelectAllMatching ? allMatchingItemsSelected : $helpers.allSelected();;
        __jade_nodes = __jade_nodes.concat((checkboxItems.length) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((displaySelectAll || displaySelectAllMatching) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("li", {
              "on": {
                click: displaySelectAllMatching ? $helpers.toggleSelectAllMatching : $helpers.toggleSelectAll
              },
              "class": Object.assign({}, {
                'mp-checkbox-list-two-columns': numColumns === 2,
                'mp-checkbox-list-three-columns': numColumns === 3,
                'mp-checkbox-list-four-columns': numColumns === 4,
              }, {
                'mp-checkbox-list-checkbox-item': true,
                'mp-checkbox-list-checkbox-select-all': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  'mp-checkbox-list-checkbox-dash': !allSelected
                }, {
                  'mp-checkbox-list-checkbox-select-icon': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: allSelected ? 'checkmark' : 'dash'
                  }),
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-checkbox-list-checkbox-label': true
                },
              }, [__vjadeSafeCode(displaySelectAllMatching ? `Select all matching` : `Select all`)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (checkboxItems);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  const isFocused = focusedItemIndex === item.index;
                  const isSelected = item.isSelected;
                  __jade_nodes = __jade_nodes.concat(h("li", {
                    "on": {
                      click: () => $helpers.handleClickItem(item),
                      mouseenter: () => $helpers.handleMouseenterItem(item),
                    },
                    "class": Object.assign({}, {
                      'mp-checkbox-list-focused': isFocused,
                      'mp-checkbox-list-two-columns': numColumns === 2,
                      'mp-checkbox-list-three-columns': numColumns === 3,
                      'mp-checkbox-list-four-columns': numColumns === 4,
                    }, {
                      'mp-checkbox-list-checkbox-item': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": Object.assign({}, {
                        'mp-checkbox-list-colored': isSelected
                      }, {
                        'mp-checkbox-list-checkbox-select-icon': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'checkmark',
                          empty: !isSelected
                        }),
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-checkbox-list-checkbox-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((item.matches) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((function() {
                          var $$obj = (item.matches);
                          var $$eachNodes;
                          var $$iterated = false;
                          if (Array.isArray($$obj)) {
                            $$eachNodes = $$obj.reduce(function($$eachNodes, substr, si) {
                              $$iterated = true;
                              return $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("span", {
                                  "class": Object.assign({}, {
                                    'matches-search': !(si % 2)
                                  }, {
                                    'substr': true
                                  }),
                                }, [__vjadeSafeCode(substr)]));;
                                return __jade_nodes
                              }).call(this));
                            }, []);
                          } else {
                            $$eachNodes = [];
                            for (var $$objKey in $$obj) {
                              (function() {
                                var si = $$objKey;
                                if ($$obj.hasOwnProperty(si)) {
                                  $$iterated = true;
                                  var substr = $$obj[si];
                                  $$eachNodes = $$eachNodes.concat((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("span", {
                                      "class": Object.assign({}, {
                                        'matches-search': !(si % 2)
                                      }, {
                                        'substr': true
                                      }),
                                    }, [__vjadeSafeCode(substr)]));;
                                    return __jade_nodes
                                  }).call(this));
                                }
                              })();
                            }
                          }

                          return $$eachNodes;
                        })());;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "class": {
                            'label': true
                          },
                        }, [__vjadeSafeCode(item.label)]));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var $index = $$objKey;
                  if ($$obj.hasOwnProperty($index)) {
                    $$iterated = true;
                    var item = $$obj[$index];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const isFocused = focusedItemIndex === item.index;
                      const isSelected = item.isSelected;
                      __jade_nodes = __jade_nodes.concat(h("li", {
                        "on": {
                          click: () => $helpers.handleClickItem(item),
                          mouseenter: () => $helpers.handleMouseenterItem(item),
                        },
                        "class": Object.assign({}, {
                          'mp-checkbox-list-focused': isFocused,
                          'mp-checkbox-list-two-columns': numColumns === 2,
                          'mp-checkbox-list-three-columns': numColumns === 3,
                          'mp-checkbox-list-four-columns': numColumns === 4,
                        }, {
                          'mp-checkbox-list-checkbox-item': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": Object.assign({}, {
                            'mp-checkbox-list-colored': isSelected
                          }, {
                            'mp-checkbox-list-checkbox-select-icon': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              icon: 'checkmark',
                              empty: !isSelected
                            }),
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'mp-checkbox-list-checkbox-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((item.matches) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((function() {
                              var $$obj = (item.matches);
                              var $$eachNodes;
                              var $$iterated = false;
                              if (Array.isArray($$obj)) {
                                $$eachNodes = $$obj.reduce(function($$eachNodes, substr, si) {
                                  $$iterated = true;
                                  return $$eachNodes.concat((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("span", {
                                      "class": Object.assign({}, {
                                        'matches-search': !(si % 2)
                                      }, {
                                        'substr': true
                                      }),
                                    }, [__vjadeSafeCode(substr)]));;
                                    return __jade_nodes
                                  }).call(this));
                                }, []);
                              } else {
                                $$eachNodes = [];
                                for (var $$objKey in $$obj) {
                                  (function() {
                                    var si = $$objKey;
                                    if ($$obj.hasOwnProperty(si)) {
                                      $$iterated = true;
                                      var substr = $$obj[si];
                                      $$eachNodes = $$eachNodes.concat((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("span", {
                                          "class": Object.assign({}, {
                                            'matches-search': !(si % 2)
                                          }, {
                                            'substr': true
                                          }),
                                        }, [__vjadeSafeCode(substr)]));;
                                        return __jade_nodes
                                      }).call(this));
                                    }
                                  })();
                                }
                              }

                              return $$eachNodes;
                            })());;
                            return __jade_nodes
                          }).call(this)) : ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("span", {
                              "class": {
                                'label': true
                              },
                            }, [__vjadeSafeCode(item.label)]));;
                            return __jade_nodes
                          }).call(this)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "focusedItemIndex" in locals ? locals.focusedItemIndex : typeof focusedItemIndex !== "undefined" ? focusedItemIndex : undefined, "numColumns" in locals ? locals.numColumns : typeof numColumns !== "undefined" ? numColumns : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "showSelectAll" in locals ? locals.showSelectAll : typeof showSelectAll !== "undefined" ? showSelectAll : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;